export class AssessmentType {
  static assessment = 0;
  static assessmentTemplate = 1;
  static assessmentTemplatePreview = 2;
}
